import { Button, Typography, makeStyles } from '@material-ui/core'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import React from 'react'

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        gap: pxToRem(16),
        padding: pxToRem(24),
        textAlign: 'center',
    },
    icon: {
        fontSize: pxToRem(48),
        color: '#C62828',
    },
    title: {
        fontSize: pxToRem(15),
        fontWeight: 600,
        color: '#314959',
    },
    message: {
        fontSize: pxToRem(13),
        color: '#637381',
        maxWidth: pxToRem(280),
    },
}))

/** Props for {@link SpecIntelligenceErrorView}. */
export interface SpecIntelligenceErrorViewProps {
    /** Error detail from the failed report or polling status; null shows no detail text. */
    errorMessage: string | null
    /** Called when the user clicks Re-run Analysis. */
    onRerun: () => void
}

/**
 * Full-height error state shown when a SpecIntelligence run fails.
 * Displays a generic "Analysis failed" heading, an optional server error detail,
 * and a Re-run Analysis button so the user can retry without closing the drawer.
 */
const SpecIntelligenceErrorView = ({ errorMessage, onRerun }: SpecIntelligenceErrorViewProps) => {
    const classes = useStyles()
    return (
        <div className={classes.root} role="alert">
            <ErrorOutlineIcon className={classes.icon} aria-hidden="true" />
            <Typography component="h3" className={classes.title}>Analysis failed</Typography>
            {errorMessage && (
                <Typography className={classes.message}>{errorMessage}</Typography>
            )}
            <Button variant="contained" color="primary" size="small" onClick={onRerun}>
                Re-run Analysis
            </Button>
        </div>
    )
}

export default SpecIntelligenceErrorView
